import { render, staticRenderFns } from "./HideMenuPage.vue?vue&type=template&id=70cf6216&scoped=true"
import script from "./HideMenuPage.vue?vue&type=script&lang=js"
export * from "./HideMenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf6216",
  null
  
)

export default component.exports